import { ClientOngoingLoad, OngoingLoadStatus } from '@numeo/types-core'

/** Guard both full snapshots and trip motion patches against delayed websocket delivery. */
export function shouldIgnoreLoadUpdate(base: ClientOngoingLoad | undefined, update: Partial<ClientOngoingLoad>): boolean {
    if (!base) return false
    if (base.updatedAt && update.updatedAt && new Date(update.updatedAt).getTime() < new Date(base.updatedAt).getTime()) return true

    // A source-stamped patch without truckId is telemetry, not an assignment change.
    if (update.truckMotionSourceTruckId && update.truckId === undefined) {
        if (base.truckId !== update.truckMotionSourceTruckId || base.status !== OngoingLoadStatus.IN_TRANSIT) return true
        if (base.truckMotionSourceTruckId === update.truckMotionSourceTruckId && base.truckMotionLastUpdatedAt && update.truckMotionLastUpdatedAt) {
            return new Date(update.truckMotionLastUpdatedAt).getTime() < new Date(base.truckMotionLastUpdatedAt).getTime()
        }
    }
    return false
}
